export const environment = {
  production: true,
  client_id: 'TEST',
  redirectUri:  'https://shop.brover.nl/auth/callback',
  auth_api: 'https://auth.brover.nl/',
  resource_api: 'https://api.brover.nl/',
  uploads: 'https://api.brover.nl/assets/'
};
